<template>
  <div :class="[
    !showNavbar ? 'do-not-display-nav-bar' : '',
    'crtvup-text-book-reader-' + pageType,
  ]">
    <!-- 征订数字教材阅读器 -->
    <xml-digital-teaching v-if="digitalTeaching" ref="xmlDigitalTeaching" :textBookData="textBookData"
      :catalogList="catalogList" :looseLeafData="looseLeafData" :bookGraphData="bookGraphData"
      :bookGraphIndexs="bookGraphIndexs" :location="location" :notesList="notesList" :bookmarkList="bookmarkList"
      :textDomList="contentList" :continueReading="false" :readOnly="false" :isTrial="isTrial"
      :isTrialIndex="isTrialIndex" :testPaperPath="testURL" :showoQuestionBank="showoQuestionBank"
      @updateReadLocation="updateReadLocation" @confirm="confirm" @updateNotes="updateNotes" @deleteNotes="deleteNotes"
      @addBookmark="addBookmark" @deleteBookmark="deleteBookmark" @downloadFile="downloadFile" @addTextDom="addTextDom"
      @updateTextDom="updateTextDom" @deleteTextDom="deleteTextDom" :basisPath="basisPath" :pageType="pageType"
      :trialText="trialText" :trialPrompt="trialPrompt" :isShowAi="textBookData.showAi" @setanalysis="setanalysis"
      systemEnvId="d58a0f05-b562-46fc-9516-55be91e21655" looseleafUrl="https://looseleaf-v2.ysy.crtvup.com.cn/"
      :updateFREQUENCY="1000" :isOpenHyperlink="true" :catalogLevel="6" loadingMode="roll"
      @learningStatistics="learningStatistics" @openQuestionBank="openQuestionBank"
      @openStudyPlan="$refs.studyPlan.open()" />

    <xml-robot ref="xmlRobot" :bookName="textBookData.textBooksName" :goodsId="goodsId"
      v-if="textBookData.showAi == '0' && pageType != 'pc'" />
    <robot ref="robot" :goodsId="goodsId" :bookName="textBookData.textBooksName"
      v-if="textBookData.showAi == '0' && pageType == 'pc'" />
    <el-dialog width="90%" :visible.sync="showXmlDialog" top="20px" center>
      <iframe width="100%" :height="iframeHeight" :src="iframeSrc" frameborder="0"></iframe>
    </el-dialog>
    <StudyPlan ref="studyPlan" :dataList="catalogList" />
  </div>
</template>

<script>
import xmlRobot from "@/components/xmlRobot/xmlRobot";
import robot from "@/components/robot.vue";
import {
  getTextBookInfo,
  getTextBookCatalog,
  getTextBookLooseLeaf,
  getLeaf,
  getGraphAnchorIndexList,
} from "@/api/looseleaf/looseleaf";
import { getCatalogInfoById } from "@/api/mobileterminalread/index";
import { goodsInfoDetail, addOrUpdate } from "@/api/bookstore/bookstore";
import StudyPlan from "./components/plan.vue";
import { getBrowserToken } from "@/utils/auth.js"
import { Utils } from 'elegant-tools-js';

import { testURL } from "@/utils/config";
import { getBookGraphs } from "@/api/jiurui";
export default {
  components: { xmlRobot, robot, StudyPlan },
  data() {
    return {
      digitalTeaching: false,
      textBookData: {},
      catalogList: [],
      looseLeafData: {},
      bookGraphData: {},
      bookGraphIndexs: [],
      trialText: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      trialPrompt: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      location: "",
      basisPath: "",
      notesList: [],
      bookmarkList: [],
      pageType: "pc",
      contentList: [],
      isTrial: true,
      isTrialIndex: 10,
      textBookId: "1660446560604454912",
      isShow: "",
      showRobot: true,
      testURL: testURL,
      showNavbar: true,
      videoNum: 0,
      audioNum: 0,
      showoQuestionBank: false,
      goodsInfo: {},
      showXmlDialog: false,
      iframeSrc: "",
    };
  },
  provide() {
    return {
      getXmlShadowingConfig: () => ({
        APPID: '98fcf4d6',//
        API_SECRET: 'Y2FkN2Y1MGZjN2U0M2I1MTU4Y2FlZjA0',
        API_KEY: 'b7e405d6af09050e4a6976f31ec37640'
      }),
    }
  },
  computed: {
    iframeHeight() {
      return window.innerHeight - 150 + "px";
    },
  },
  created() {
    let tokenData=getBrowserToken()||'{}'
    tokenData=JSON.parse(tokenData)
    
    if(tokenData&&tokenData.browserFinger){
      let browserFinger = Utils.getBrowserFingerprint()
      if(browserFinger!=browserFinger){
        this.$message.error('您当前没有访问权限，请先登录')
        setTimeout(()=>{
          this.$router.push({ path: '/' })
        },2000)
        return
      }
    }
    
    
    let router = this.$route.query;
    let version = router.source;
    if (router.textBookId) {
      this.textBookId = router.textBookId;
    }
    this.showNavbar = router.showNavbar == "0" ? false : true;
    if (router.pageType) {
      this.pageType = router.pageType;
    }
    if (router.goodsId) {
      this.goodsId = router.goodsId;
    }
    if (router.isTrial=="true"||tokenData.isTrial=="true") {
      this.isTrial = true;
    }else{
      this.isTrial = false;
    }
    goodsInfoDetail(router.goodsId).then((res) => {
      this.goodsInfo = res.data || {};
      if (this.goodsInfo.goods.questionBankId) {
        this.showoQuestionBank = true;
      } else {
        this.showoQuestionBank = false;
      }
      if (this.goodsInfo?.sourceList[0]?.sourceType == "V3") {
        version = "v3";
      }

      if (
        router.catalogId !== "" &&
        router.catalogId !== "undefined" &&
        router.catalogId !== "null" &&
        router.catalogId
      ) {
        getTextBookInfo(this.textBookId, version).then((res) => {
          this.textBookData = res.data;
          this.getGraphData();
        });
        this.catalogId = router.catalogId;
        getCatalogInfoById({ catalogId: router.catalogId, type: version }).then(
          (res) => {
            this.queryData(res.data);
          }
        );
      } else if (router.businessType == "textBook") {
        getTextBookInfo(this.textBookId, version).then((res) => {
          this.textBookData = res.data;
          getTextBookCatalog(
            this.textBookId,
            "1",
            this.textBookData.publishVersionId || "",
            version
          ).then((res) => {
            this.catalogList = res.data;
          });
          getTextBookLooseLeaf(
            this.textBookId,
            this.textBookData.publishVersionId || "",
            version
          ).then((res) => {
            this.looseLeafData = JSON.parse(res.msg);
            setTimeout(() => {
              this.digitalTeaching = true;
            }, 500);
          });
          this.getGraphData();
          if (res.code == 200 && res.data.xiaoZhi) {
            this.textBookData.showAi = '0'
          }
          this.$emit("getbookinfo", this.textBookData);
        });
      } else if (router.businessType == "looseLeaf") {
        getLeaf(this.textBookId, version).then((res) => {
          this.textBookData = res.data;
          this.catalogList = [
            {
              children: [],
              hiddenFlag: "0",
              id: this.textBookId,
              label: res.data.looseLeafName,
              level: null,
              orderNum: 0,
              parentId: null,
              uploadFileUrl: "",
            },
          ];

          let looseLeafData = {};
          looseLeafData[this.textBookId] = res.data;

          this.looseLeafData = {
            ...looseLeafData,
          };
          setTimeout(() => {
            this.digitalTeaching = true;
          }, 500);
        });
      }
    });

    // this.location = localStorage.getItem(this.textBookData.id);
    this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
    this.bookmarkList = JSON.parse(localStorage.getItem("bookmarkList")) || [];
    this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    // this.location = localStorage.getItem(this.textBookId);
  },

  mounted() {
    let _this = this;
    let router = this.$route.query;
  },
  methods: {
    openQuestionBank() {
      if (this.pageType == "pc") {
        const { href } = this.$router.resolve({
          path: "/bookstore/generateQuestions",
          query: {
            goodsId: this.goodsInfo.goods.questionBankId,
            resourceType: "goods",
            resource: "bookCity",
            relevanceId: this.goodsInfo.goods.questionBankId,
            bookName: this.goodsInfo.goods.questionBankName,
            showAi: true,
            minWin: "1"
          },
        });
        // window.open(href, "_blank");

        // this.iframeSrc = "/" + href;
        this.iframeSrc = href;
        this.showXmlDialog = true;
      } else {
        this.myUni.postMessage({
          data: {
            name: "openQuestionBank",
            value: {
              goodsId: this.goodsInfo.goods.questionBankId,
              resourceType: "goods",
              resource: "bookCity",
              relevanceId: this.goodsInfo.goods.questionBankId,
              bookName: this.goodsInfo.goods.questionBankName,
            },
          },
        });
      }
    },
    getGraphData() {
      if (this.textBookData.courseCode) {
        getBookGraphs({
          courseCode: this.textBookData.courseCode,
        }).then((res) => {
          this.bookGraphData = res.data;
        });
      }
      // getGraphAnchorIndexList({
      //   courseCode: this.textBookData.courseCode,
      // }).then(res => {
      //   this.bookGraphIndexs = res.rows || []
      // })
    },
    // 确认添加笔记
    confirm(e) {
      this.notesList.push(e);
      let list = JSON.stringify(this.notesList);
      localStorage.setItem("notesList", list);
      this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
      // 添加笔记成功后显示笔记标记
      this.$refs.xmlDigitalTeaching.addNotesSign(e.location, "notes");
    },

    // 更新笔记
    updateNotes(e) {
      this.notesList.map((item, index) => {
        if (item.notesId === e.notesId) {
          this.notesList[index].notesContent = item.notesContent;
          localStorage.setItem("notesList", JSON.stringify(this.notesList));
          this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
        }
      });
    },

    // 删除笔记
    deleteNotes(e) {
      this.notesList.map((item, index) => {
        if (item.notesId === e.notesId) {
          this.notesList.splice(index, 1);
          localStorage.setItem("notesList", JSON.stringify(this.notesList));
          this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
          // 删除笔记成功后删除笔记标记
          this.$refs.xmlDigitalTeaching.deleteNotesSign(e.location, "notes");
        }
      });
    },

    addTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      // const index = this.contentList.findIndex((item) => item.domId == e.location)
      // if (index == -1) {
      this.contentList.push({
        id: e.id,
        contentDom: e.contentDom,
        domId: e.domId,
      });
      // } else {
      // this.contentList[index].contentDom = e.contentDom
      // }
      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },
    updateTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      const index = this.contentList.findIndex((item) => item.domId == e.domId);
      this.contentList[index].contentDom = e.contentDom;
      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },
    deleteTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      const index = this.contentList.findIndex((item) => item.domId == e.domId);
      this.contentList.splice(index, 1);

      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },

    // 添加书签
    addBookmark(e) {
      this.bookmarkList.push(e);
      let list = JSON.stringify(this.bookmarkList);
      localStorage.setItem("bookmarkList", list);
      this.bookmarkList =
        JSON.parse(localStorage.getItem("bookmarkList")) || [];
      // 添加书签成功后显示书签标记
      this.$refs.xmlDigitalTeaching.addNotesSign(e.location, "bookmark");
    },

    // 删除书签
    deleteBookmark(e) {
      this.bookmarkList.map((item, index) => {
        if (item.bookmarkId === e.bookmarkId) {
          this.bookmarkList.splice(index, 1);
          localStorage.setItem(
            "bookmarkList",
            JSON.stringify(this.bookmarkList)
          );
          this.bookmarkList =
            JSON.parse(localStorage.getItem("bookmarkList")) || [];
          // 删除书签成功后删除书签标记
          this.$refs.xmlDigitalTeaching.deleteNotesSign(e.location, "bookmark");
        }
      });
    },

    // 下载资源文件
    downloadFile(e) { },

    // 更新阅读进度
    updateReadLocation(newLocation) {
      localStorage.setItem(this.textBookData.id, JSON.stringify(newLocation));
    },
    //AI解析
    setanalysis(data) {
      console.log(data);
      // 向父vue页面发送信息
      window.parent.postMessage(
        {
          data,
        },
        "*"
      );
    },

    queryData(data) {
      let bookInfo = {};

      const getItemByChild = (list, label) => {
        console.log(list, "aaaaaaaaaaaaaaaa");

        for (let i = 0; i < list.length; i++) {
          this.$set(list[i], "label", list[i].catalogName);
          let it = list[i];
          bookInfo[it.id] = it;
          if (it.children) {
            getItemByChild(it.children);
          }
        }
        this.looseLeafData = bookInfo;
        if (data[0].children?.length > 0) {
          for (let i = 0; i < data[0].children.length; i++) {
            this.$set(data[0].children[i], "hiddenFlag", "1");
          }
        }
        setTimeout(() => {
          this.digitalTeaching = true;
          this.catalogList = data;
        }, 500);
      };
      getItemByChild(data);
    },
    learningStatistics(e) {
      // console.log('111111111111111==============================',e);
      if (e.type == "doc" || e.type == "ebook") {
        this.addOrUpdate("doc", e.title || "");
      } else if (e.type == "question") {
        this.addOrUpdate("paper", "");
      } else if (e.type == "question") {
        this.addOrUpdate("paper", "");
      } else if (e.type == "video") {
        this.videoNum++;
        if (this.videoNum > 60) {
          this.videoNum = 0;
          this.addOrUpdate("video", e.title || "");
        }
      } else if (e.type == "audio") {
        this.audioNum++;
        if (this.audioNum > 60) {
          this.audioNum = 0;
          this.addOrUpdate("audio", e.title || "");
        }
      }
    },

    addOrUpdate(type, fileName) {
      let data = JSON.parse(localStorage.getItem(this.textBookId));

      let idData = JSON.parse(
        localStorage.getItem("xml-reader-type-id-list")
      ) || {
        book: "",
        video: "",
        autio: "",
        paper: "",
        doc: "",
      };

      let readerData = {
        id: idData[type],
        goodsFileId: this.textBookId,
        goodsId: this.$route.query.goodsId,
        chaptId: data.chapterId,
        chaptName: data.chaptName,
        platformCode: this.$route.query.sysId,
        readingLocation: data.location,
        stuNum: this.$route.query.userFlag || 0,
        readSchedule: data.schedule || 0,
        readingTime: 1,
        type: type, //	资源类型（视频：video,音频：autio,试卷：paper,其他：doc,教材：book）
        source: "h5", //来源(pc、h5、app、xcx)
        fileName: fileName,
      };

      addOrUpdate(readerData).then((res) => {
        idData[type] = idData[type] ? idData[type] : res.data;
        localStorage.setItem("xml-reader-type-id-list", JSON.stringify(idData));
      });
    },
  },
};
</script>

<style lang="scss">
.xml-digital-teaching-preview .xml-preview-catalog-pc {
  width: 100%;
}

.ouchn-container.preview-mode .preview-tree-box-h5 .catalog-node__left .catalog-node__label {
  width: 100%;
}

.crtvup-text-book-reader-pc {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 850px;
  }

  .ouchn-container.preview-mode .preview-container-title-pc .container-iocn-search-pc {
    top: 15px;
  }

  .xml-single-question-group-pc {
    .shop-item-img {
      img {
        width: 100%;
      }
    }
  }

  .ouchn-container .parent-group {
    padding: 16px 50px;
  }

  // .tab-title-pc {
  //   display: none;
  // }
  .xml-single-question-group-pc {
    .group-content-box {
      .stem-box {
        display: flex;

        .question-number {
          padding-right: 4px;
          line-height: 28px;
        }
      }
    }
  }

  .ouchn-container.preview-mode .preview-tree-box-pc .catalog-node__left .catalog-node__label {
    width: 100%;
  }

  .ouchn-container.preview-mode .preview-tree-box-pc {
    padding: 15px 4px;
  }
}

.do-not-display-nav-bar {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 700px;
  }

  .ouchn-container .parent-group {
    padding: 16px 30px;
  }

  .preview-container-title-pc {
    display: none !important;
  }

  .pc-catalog.pc-catalog--render {
    margin-top: 0 !important;
    height: calc(100vh - 6px) !important;
  }

  .ouchn-container.preview-mode .preview-tree-box-pc.custom-catalog-tree {
    height: calc(100vh - 46px) !important;
  }

  .tab-title-pc {
    top: 0 !important;
  }

  .preview-list-counter-pc {
    margin: 0 auto 40px auto !important;
    height: calc(100vh - 46px) !important;
    padding-top: 0 !important;
  }

  .preview-list-pc {
    height: calc(100vh - 40px) !important;
  }

  .tab-title-pc {
    display: none !important;
  }

  .add-notes-bookmarks-pc {
    display: none !important;
  }

  .tab-title-pc {
    .catalog-tab {
      display: none !important;
    }
  }
}

.xml-digital-teaching-preview .xml-digital-teaching-pc {
  min-width: 800px !important;
}

@media screen and (max-width: 1200px) {
  .xml-digital-teaching-preview .xml-digital-teaching-pc .preview-container-pc-left {
    width: 240px !important;
  }

  .xml-reader-preview-guokai .xml-digital-teaching-pc .preview-counter-main-pc {
    box-shadow: none !important;
  }
}
</style>
